import { AccountsServiceClient } from '@pushwoosh/rpc-service-client/pushwoosh/accounts/AccountsServiceClientPb';
import {
  Account,
  BillingAddress,
  BillingInfo,
  GetAccountRequest,
  GetAccountResponse,
  GetActiveDevicesCountRequest,
  GetActiveDevicesCountResponse,
  GetActiveUsersCountRequest,
  GetActiveUsersCountResponse,
  GetBillingInfoRequest,
  GetBillingInfoResponse,
  GetEmailStatisticCountRequest,
  GetEmailStatisticCountResponse,
  GetOnboardingInfoRequest,
  GetOnboardingInfoResponse,
  GetSubscribersCountRequest,
  GetSubscribersCountResponse,
  GetTotalEmailSubscribersCountRequest,
  GetTotalEmailSubscribersCountResponse,
  SetDebugModeRequest,
  SetDebugModeResponse,
  UpdateAccountRequest,
  UpdateAccountResponse,
  UpdateBillingInfoRequest,
  UpdateBillingInfoResponse,
  UpdateOnboardingInfoRequest,
  UpdateOnboardingInfoResponse,
} from '@pushwoosh/rpc-service-client/pushwoosh/accounts/accounts_pb';

import { GetAuthInfoServiceClient } from '@pushwoosh/rpc-service-client/pushwoosh/accounts/Get_auth_infoServiceClientPb';
import {
  Account as AuthInfoAccount,
  User as AuthInfoUser,
  GetAuthInfoRequest,
} from '@pushwoosh/rpc-service-client/pushwoosh/accounts/get_auth_info_pb';

export type AccountsExportClasses = {
  AccountsServiceClient: typeof AccountsServiceClient;
  Account: typeof Account;
  BillingAddress: typeof BillingAddress;
  BillingInfo: typeof BillingInfo;
  GetAccountRequest: typeof GetAccountRequest;
  GetAccountResponse: typeof GetAccountResponse;
  GetActiveDevicesCountRequest: typeof GetActiveDevicesCountRequest;
  GetActiveDevicesCountResponse: typeof GetActiveDevicesCountResponse;
  GetActiveUsersCountRequest: typeof GetActiveUsersCountRequest;
  GetActiveUsersCountResponse: typeof GetActiveUsersCountResponse;
  GetBillingInfoRequest: typeof GetBillingInfoRequest;
  GetBillingInfoResponse: typeof GetBillingInfoResponse;
  GetEmailStatisticCountRequest: typeof GetEmailStatisticCountRequest;
  GetEmailStatisticCountResponse: typeof GetEmailStatisticCountResponse;
  GetOnboardingInfoRequest: typeof GetOnboardingInfoRequest;
  GetOnboardingInfoResponse: typeof GetOnboardingInfoResponse;
  GetSubscribersCountRequest: typeof GetSubscribersCountRequest;
  GetSubscribersCountResponse: typeof GetSubscribersCountResponse;
  GetTotalEmailSubscribersCountRequest: typeof GetTotalEmailSubscribersCountRequest;
  GetTotalEmailSubscribersCountResponse: typeof GetTotalEmailSubscribersCountResponse;
  SetDebugModeRequest: typeof SetDebugModeRequest;
  SetDebugModeResponse: typeof SetDebugModeResponse;
  UpdateAccountRequest: typeof UpdateAccountRequest;
  UpdateAccountResponse: typeof UpdateAccountResponse;
  UpdateBillingInfoRequest: typeof UpdateBillingInfoRequest;
  UpdateBillingInfoResponse: typeof UpdateBillingInfoResponse;
  UpdateOnboardingInfoRequest: typeof UpdateOnboardingInfoRequest;
  UpdateOnboardingInfoResponse: typeof UpdateOnboardingInfoResponse;

  GetAuthInfoServiceClient: typeof GetAuthInfoServiceClient;
  GetAuthInfoRequest: typeof GetAuthInfoRequest;
  AuthInfoAccount: typeof AuthInfoAccount;
  AuthInfoUser: typeof AuthInfoUser;
};

export const accounts: AccountsExportClasses = {
  AccountsServiceClient,
  Account,
  BillingAddress,
  BillingInfo,
  GetAccountRequest,
  GetAccountResponse,
  GetActiveDevicesCountRequest,
  GetActiveDevicesCountResponse,
  GetActiveUsersCountRequest,
  GetActiveUsersCountResponse,
  GetBillingInfoRequest,
  GetBillingInfoResponse,
  GetEmailStatisticCountRequest,
  GetEmailStatisticCountResponse,
  GetOnboardingInfoRequest,
  GetOnboardingInfoResponse,
  GetSubscribersCountRequest,
  GetSubscribersCountResponse,
  GetTotalEmailSubscribersCountRequest,
  GetTotalEmailSubscribersCountResponse,
  SetDebugModeRequest,
  SetDebugModeResponse,
  UpdateAccountRequest,
  UpdateAccountResponse,
  UpdateBillingInfoRequest,
  UpdateBillingInfoResponse,
  UpdateOnboardingInfoRequest,
  UpdateOnboardingInfoResponse,

  GetAuthInfoServiceClient,
  GetAuthInfoRequest,
  AuthInfoAccount,
  AuthInfoUser,
}
